const locales = {
  en: 'English',
  en_US: 'English (United States)',
  pt_BR: 'Portuguese (Brazil)',
  es: 'Spanish',
};
export default locales;
